import { render, staticRenderFns } from "./filter-select.vue?vue&type=template&id=52b83329&scoped=true"
import script from "./filter-select.vue?vue&type=script&lang=js"
export * from "./filter-select.vue?vue&type=script&lang=js"
import style0 from "./filter-select.vue?vue&type=style&index=0&id=52b83329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b83329",
  null
  
)

export default component.exports